import { createEmptyContext } from '../../../../utils/create-empty-context';
export const MemberSignInFormContextInstance = createEmptyContext();
//# sourceMappingURL=context.js.map